module.exports = __webpack_public_path__ + "media/point-4.280a3ffb.wav";